<!--
/**
* @name: List.vue
* @description: 评价管理
* @author: 杨波
* @create: 2020/09/08 10:39:33
* @update: 2020/09/08 10:39:33
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择销售渠道" block clearable v-model="para.saleChannelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入订单号" clearable v-model="para.orderNo"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入商品货号" clearable v-model="para.goodsCodeSale"></k-input>
      </y-query-item>
      <y-query-item slot="right">
        <k-dropdown :title="title()" layerMinWidthEqual>
          <k-option @click="onBatchAudit">批量审核</k-option>
          <k-option @click="onBatchReject">批量驳回</k-option>
        </k-dropdown>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择状态" clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="createDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择创建时间 " style="width: 300px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <y-query-item>
          <k-button type="primary" @click="onSearch">查询</k-button>
        </y-query-item>
        <y-query-item>
          <k-button @click="onReset">重置</k-button>
        </y-query-item>
      </y-query-item>
    </y-query>
    <k-table :data="commentList" hasCheckbox checkboxKey="id" :selectedKeys.sync="selectedKeys" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_PAGE,
  NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_AUDIT,
  NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_REJECT,
} from "@/assets/modules/apiList";
const initPara = () => ({
  saleChannelCode: "",
  orderNo: "",
  goodsCodeSale: "",
  status: "",
  createTimeStart: "",
  createTimeEnd: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      channelList: [],
      createDate: "",
      commentList: [],
      para: initPara(),
      selectedKeys: [],
      total: 0,
      isLoading: false,
      statusList: [
        { value: "WAIT", label: "待审批" },
        { value: "SUCCESS", label: "已审批" },
        { value: "REJECT", label: "驳回" },
      ],
    };
  },
  computed: {
    startTime() {
      return this.createDate[0];
    },
    endTime() {
      return this.createDate[1];
    },
  },
  methods: {
    title() {
      return (
        <k-button type="primary">
          批量操作
          <k-icon name="k-icon-arrow-down" />
        </k-button>
      );
    },
    changeDate(date) {
      this.createDate = date;
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    initColumns() {
      return [
        {
          name: "销售渠道",
          field: "saleChannelName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "订单号",
          field: "orderNo",
          style: {
            width: 200,
            textAlign: "center",
          },
        },
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "敏感词",
          field: "sensitiveWords",
          style: {
            width: 140,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "status",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => {
            const statusStr = row.status == "WAIT" ? <span>待审批</span> : row.status == "SUCCESS" ? <span>已审批</span> : <span>驳回</span>;
            return <div>{statusStr}</div>;
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            return <div>{previewButton}</div>;
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getCommentList();
    },
    onReset() {
      this.para = initPara();
      this.createDate = "";
      this.getCommentList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getCommentList();
    },
    onView(row) {
      // 新开标签
      this.$controller.open({
        name: "evaluateDetail",
        query: {
          refresh: new Date() - 0,
          id: row.id,
        },
      });
    },
    onBatchAudit() {
      const { tip } = this.$root;
      if (this.selectedKeys.length === 0) {
        return tip("请选择需审批评价");
      }
      this.$dialog({
        title: "提示",
        content: "是否确认审批当前选中评价？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_AUDIT,
            para: { idList: this.selectedKeys },
          })
            .then(() => {
              this.isLoading = false;
              this.getCommentList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onBatchReject() {
      const { tip } = this.$root;
      if (this.selectedKeys.length === 0) {
        return tip("请选择需驳回评价");
      }
      this.$dialog({
        title: "提示",
        content: "是否确认驳回当前选中评价？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_REJECT,
            para: { idList: this.selectedKeys },
          })
            .then(() => {
              this.isLoading = false;
              this.getCommentList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getCommentList() {
      let { para } = this;
      para.createTimeStart = this.createDate && this.createDate.length > 0 ? this.createDate[0] : "";
      para.createTimeEnd = this.createDate && this.createDate.length > 0 ? this.createDate[1] : "";
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_PAGE,
        para,
      }).then((res) => {
        this.commentList = res.pageList;
        this.total = res.total;
      });
    },
  },
  created() {
    this.getChannelList();
    this.getCommentList();
  },
};
</script>

<style lang="postcss" module="css"></style>
